import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { WorkplacePoliciesEnum } from '@qaroni-app/workplace/types/workplace-policies.enum';

@Component({
  selector: 'qaroni-check-details-lead',
  templateUrl: './check-details-lead.component.html',
  styleUrls: ['./check-details-lead.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckDetailsLeadComponent {
  readonly workplacePolicies = input<WorkplacePoliciesEnum>(
    WorkplacePoliciesEnum.NON_STRICT
  );
}
